<template>
  <div>
    <b-card class="p-0 m-0" :header="survey.name">
      <b-form>
        <b-form-group v-for="(question, index) in questions" :key="index" class="mb-2">
          <label :for="`select-${index}`">{{ question.question }}:</label>
          <b-form-select
            :id="`select-${index}`"
            v-model="question.answer"
            @change="handleChange()"
            size="sm">
            <option key="0" :value="null" disabled>Select an option</option>
            <option v-for="(option, i) in question.questionOptions" :key="i+1" :value="option">
              {{ option }}
            </option>
            <optgroup label=""></optgroup>
          </b-form-select>
        </b-form-group>
        <div>
          <div v-if="!signup" class="w-100 d-flex justify-content-between pt-2">
            <b-button class="bg-danger" size="sm" @click="handleCancel">Cancel</b-button>
            <b-button class="spnod-admin__form--button" size="sm" :disabled="isDisabled" v-b-modal="modals.save._id">
              <p v-if="!isSending">Submit</p>
              <span v-else class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            </b-button>
          </div>
          <div v-else class="w-100 d-flex justify-content-between pt-2">
            <div></div>
            <b-button class="spnod-admin__form--button" size="sm" :disabled="isDisabled" @click="handleSubmit">
              <p v-if="!isSending">Submit</p>
              <span v-else class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            </b-button>
          </div>
        </div>
      </b-form>
    </b-card>

    <!--  Save Modal  -->
    <Modal
      :_id="modals.save._id"
      :message="modals.save.message"
      @success="handleSubmit" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import _ from 'lodash'
import Modal from '../Notifications/Modal'

export default {
  name: 'SurveyForm',
  components: { Modal },
  data() {
    return {
      isSending: false,
      isDisabled: true,
      survey: {},
      modals: {
        save: {
          _id: 'modal-save',
          message: 'Are you sure you want to save?'
        }
      }
    }
  },
  props: ['user', 'signup'],
  computed: {
    ...mapGetters(['getMyInfo']),
    questions: function() {
      if (this.survey && this.survey.questionsGroups) return this.survey.questionsGroups[0].questions
    }
  },
  methods: {
    ...mapActions(['submitSurvey']),
    handleCancel() {
      this.$emit('toggleSurvey')
    },
    handleSubmit: async function () {
      this.isSending = true
      await this.submitSurvey(this.survey)
      if (this.signup) {
        this.$router.push('/messages')
      } else {
        this.$emit('toggleSurvey')
      }
      this.isSending = false
    },
    handleChange() {
      this.isDisabled = !this.survey.questionsGroups[0].questions.every(q => q.answer)
    }
  },
  beforeCreate() {
    this.$store.commit('RESTARTNUTRITIONSURVEY')
  },
  mounted() {
    if (!this.user || !this.user.surveys) return
    const survey = _.cloneDeep(this.user.surveys[0])
    survey.questionsGroups[0].questions.forEach(q => {
      if (!q.answer) q.answer = null
    })
    this.survey = survey
    this.$store.commit('SETACTIVESURVEY', survey._id)
    this.$store.commit('NUTRITIONNEXTSTEP', 0)
  },
  watch: {
    user: {
      handler() {
        if (!this.user || !this.user.surveys) return
        const survey = _.cloneDeep(this.user.surveys[0])
        survey.questionsGroups[0].questions.forEach(q => {
          if (!q.answer) q.answer = null
        })
        this.survey = survey
        this.$store.commit('SETACTIVESURVEY', survey._id)
        this.$store.commit('NUTRITIONNEXTSTEP', 0)
      },
      deep: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/components/Surveys/SurveyForm.vue?5585e9e7